export const phoneNumber = {
  code: null,
  number: null
};
